import { c as classNames } from '../../shared/bind-3319d1f7.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "validation": "web_ui__Validation__validation",
  "primary": "web_ui__Validation__primary",
  "amplified": "web_ui__Validation__amplified",
  "muted": "web_ui__Validation__muted",
  "success": "web_ui__Validation__success",
  "warning": "web_ui__Validation__warning",
  "inverse": "web_ui__Validation__inverse"
};

var cssClasses = classNames.bind(styles);
var Validation = function Validation(_ref) {
  var text = _ref.text,
    theme = _ref.theme,
    testId = _ref.testId;
  var validationClass = cssClasses('validation', theme);
  return /*#__PURE__*/jsx("div", {
    className: validationClass,
    "data-testid": testId,
    children: text
  });
};

export { Validation as default };
//# sourceMappingURL=Validation.js.map
